import state from './state';
import actions from './actions';
import mutations from './mutations';

const userStore = {
  namespaced: true,
  state,
  actions,
  mutations
};

export default userStore;
